import { useModalQuery } from '../../../../../hooks/useModalQuery';

export const useWriteOffModal = () => {
  return useModalQuery('write-off-info');
};
